import { Routes } from '@angular/router';
import { TwoColumnsRightComponent } from '../upgrade/main.template.directive';
import { setupGuard } from '@fry/upgrade/setup.guard';
import { authGuard } from '@fry-it/risr-core';
import { forceOnlineGuard } from '@fry-it/risr-core';
import { unsavedGuard } from '@fry/upgrade/unsaved.guard';
import {
  RolesListComponent,
  RoleFormComponent
} from '../upgrade/roles.directive';

export const rolesRoutes: Routes = [
  {
    path: 'roles',
    component: TwoColumnsRightComponent,
    canActivate: [setupGuard, authGuard, forceOnlineGuard],
    data: {
      permission: 'roles.view'
    },
    children: [
      {
        path: '',
        component: RolesListComponent,
        data: {
          state: 'epf.roles.index'
        },
        canActivate: [forceOnlineGuard]
      },
      {
        path: 'new',
        component: RoleFormComponent,
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'roles.edit',
          state: 'epf.roles.new'
        }
      },
      {
        path: 'edit/:id',
        component: RoleFormComponent,
        canActivate: [forceOnlineGuard, authGuard],
        canDeactivate: [unsavedGuard],
        data: {
          permission: 'roles.edit',
          state: 'epf.roles.edit'
        }
      }
    ]
  }
];
